import React from 'react';
import LegalLayout, { H2, P, UL, OL } from '../components/legal/LegalLayout';

// 90-Day Pause Policy — wording VERBATIM from the official document.

export default function Pause90Page() {
  return (
    <LegalLayout title="90-DAY PAUSE POLICY" lastUpdated="August 19th, 2026" testId="pause90-page">
      <H2 id="1">1. OVERVIEW</H2>
      <P>We recognize that subscribers may need a temporary break due to vacations, exam periods, or temporary scheduling changes. Rather than cancelling your subscription and losing your account configuration, HiBFF offers a 90-Day Pause Policy.</P>

      <H2 id="2">2. HOW THE 90-DAY PAUSE WORKS (STRIPE SUBSCRIPTIONS)</H2>
      <UL items={[
        <><strong>Temporary Suspension:</strong> When you request a 90-day pause, your active subscription moves to a Paused status in Stripe at the end of your current paid billing period.</>,
        <><strong>Zero Billing During Pause:</strong> Stripe halts automated invoice generation and payment collection for exactly 90 days. You will not be charged during the pause period.</>,
        <><strong>Data &amp; Progress Protection:</strong> Your customized settings, practice history, saved avatars, and progress metrics are fully preserved in a frozen state.</>,
        <><strong>Platform Access:</strong> Access to paid features ("HiBFF Plus", Practice Partners, voice interactions) is suspended while billing is paused. You retain access to the basic free Starter features.</>,
      ]} />

      <H2 id="3">3. AUTOMATIC REACTIVATION</H2>
      <UL items={[
        <><strong>90-Day Limit:</strong> After 90 consecutive calendar days, your subscription will automatically un-pause and reactivate.</>,
        <><strong>Billing Resumption:</strong> Stripe will generate your next recurring invoice and charge your payment method on file on Day 91.</>,
        <><strong>Advance Reminder Notice:</strong> We will send an automated courtesy email to your registered email address 7 calendar days prior to the 90-day un-pause date, reminding you of the upcoming resumption.</>,
      ]} />

      <H2 id="4">4. EARLY RESUMPTION &amp; EXTENSIONS</H2>
      <UL items={[
        <><strong>Resume Anytime:</strong> You may un-pause and reactivate your subscription at any time prior to Day 90 via Account Settings or by emailing <a href="mailto:support@hibff.com" className="underline text-blue-700">support@hibff.com</a>.</>,
        <><strong>Frequency:</strong> Members may utilize a 90-Day Pause up to twice per 12-month calendar year.</>,
      ]} />

      <H2 id="5">5. HOW TO REQUEST A 90-DAY PAUSE</H2>
      <OL items={[
        <>Navigate to Settings &gt; Billing &amp; Subscription in your HiBFF portal and select Pause Subscription (90 Days).</>,
        <>Alternatively, email <a href="mailto:support@hibff.com" className="underline text-blue-700">support@hibff.com</a> with the subject Request 90-Day Subscription Pause.</>,
      ]} />
    </LegalLayout>
  );
}
